// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SalesFiltersController from "./sales_filters_controller"
application.register("sales-filters", SalesFiltersController)

import SalesUpdateExchangeRateController from "./sales_update_exchange_rate_controller"
application.register("sales-update-exchange-rate", SalesUpdateExchangeRateController)

import WatchedArtistsController from "./watched_artists_controller"
application.register("watched-artists", WatchedArtistsController)

import VideosController from "./videos_controller"
application.register("videos", VideosController)
